exports = module.exports = require("./../../node_modules/.npminstall/css-loader/0.21.0/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert-icon-float-left {\n  font-size:32px;\n  float:left;\n  margin-right:5px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/css-loader/0.21.0/css-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-fc059c9a&file=alertDocs.vue!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./docs/example/alertDocs.vue
// module id = 190
// module chunks = 0